import theme from "shared/theme";

import { EButtonColors, EButtonSizes, IButtonProps } from "./interfaces";
import styles from "./styles";

export function ButtonPrimary({
  name,
  handler,
  iconLeft,
  iconRight,
  fullWidth = false,
  size = EButtonSizes.M,
  color = EButtonColors.BLUE,
  disabled,
  textColor = theme.colors.white,
}: IButtonProps) {
  return (
    <styles.ButtonPrimaryWrapper
      type="button"
      onClick={handler}
      size={size}
      color={color}
      fullWidth={fullWidth}
      disabled={disabled}
      textColor={textColor}
    >
      {iconLeft || null}
      {name}
      {iconRight || null}
    </styles.ButtonPrimaryWrapper>
  );
}
